module.exports = __webpack_public_path__ + "img/ocultar.733da93a.svg";